import cn from 'classnames';
import { Typography } from '@arionbanki/arionui';
import { Caption, Description } from './Labels';
import { InfoIcon } from 'components';
import { QuestionContent } from './QuestionContent';
import { QuestionProps } from 'types';
import { useQuestion } from './useQuestion';

export function Question(props: QuestionProps) {
	const ctx = useQuestion(props);
	if (!ctx.isVisible) return null;

	const { depended, framed, iconTitle, isSubquestion } = ctx;
	const pcn = cn('text-secondary', { bold: !isSubquestion, 'mt-4': !isSubquestion });
	const wcn = cn({ question: !depended, depended, 'col-6': isSubquestion, framed });
	const questionContent = <QuestionContent {...props} />;
	const caption = <Caption {...props} />;

	return (
		<div className={wcn}>
			{framed ? (
				<div className="row">
					<div className="col-12">
						<Typography TagName="p" className={pcn}>
							{caption}
							{iconTitle && <InfoIcon title={iconTitle} />}
						</Typography>
					</div>
					<div className="col-12">{questionContent}</div>
				</div>
			) : (
				<>
					{!ctx.isDropdown && (
						<>
							<Typography TagName="p" className={pcn}>
								{caption}
							</Typography>
							<Description {...props} />
						</>
					)}
					{questionContent}
				</>
			)}
		</div>
	);
}
